import React, { useState, useEffect } from "react";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import { LoyaltyModel } from "./LoyaltyRewardsModel";

interface OwnProps {
    ProgressValue: LoyaltyModel;
}

//type props = OwnProps

const CircularProgressBar = ({ ProgressValue }: any) => {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            if (progress < ProgressValue) {
                setProgress(progress + 1);
            } else {
                clearInterval(interval);
            }
        }, 30);

        return () => {
            clearInterval(interval);
        };
    }, [progress, ProgressValue]);

    const radius = 40;
    const circumference = 2 * Math.PI * radius;
    const circumferenceBg = circumference - 1;
    const dashOffset = ((100 - progress) / 100) * circumference;

    return (
        <StyledWrapper>
            <svg
                className="layaltyRewards"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                viewBox="35.4 5 124 100"
                width="200"
                height="200"
            >
                <defs>
                    <style>{`
              .layaltyRewards {display: flex;position: relative; width: 180px;height: 180px;border-radius: 50%;background: #fff;left: 0%;top: 0%; box-shadow: 0 0 12px 0 rgba(0,0,0,.25);}                                       
              `}</style>
                </defs>
                <path
                    stroke="#dddddd"
                    fill="none"
                    strokeLinecap="square"
                    strokeWidth="12px"
                    d="M55,90 A55,55 0 1,1 140,90"
                ></path>
                <path
                    stroke="#ffffff"
                    fill="none"
                    strokeLinecap="square"
                    strokeWidth="12px"
                    d="M55,90 A55,55 0 1,1 140,90"
                    r={radius}
                    strokeDasharray={`${circumference}`}
                    strokeDashoffset={dashOffset}
                ></path>
                <path
                    stroke="#002856"
                    fill="none"
                    strokeLinecap="square"
                    strokeWidth="12px"
                    d="M55,90 A55,55 0 1,1 140,90"
                    r={radius}
                    strokeDasharray={`${circumferenceBg}`}
                    strokeDashoffset={dashOffset}
                ></path>
            </svg>
        </StyledWrapper>
    );
};

export default CircularProgressBar;